module.exports = __webpack_public_path__ + "static/media/tips_image.e0eb6705.png";